import { Routes } from '@angular/router';
import { DashboardGuardService } from '../../core/auth/guards/dashboard-guard.service';
import { LoggedInGuard } from '../../core/auth/guards/logged-in-guard.service';
import { USER_UI_PATH_ELEMENTS } from '../../core/users/definitions/user-ui-navigation.definitions';
import { UserDetailsComponent } from './components/user-details/user-details.component';
import { UsersListComponent } from './components/users-list/users-list.component';

export const usersUiRoutes: Routes = [
  {
    path: USER_UI_PATH_ELEMENTS.rootElement,
    canActivate: [LoggedInGuard, DashboardGuardService],
    children: [
      {
        path: '',
        pathMatch: 'full',
        component: UsersListComponent,
      },
      {
        path: `:id`,
        component: UserDetailsComponent,
      },
      {
        path: '**',
        redirectTo: `/${USER_UI_PATH_ELEMENTS.rootElement}`,
      },
    ],
  },
];
